import {
  Bell,
  Boxes,
  Building2,
  Calculator,
  GaugeCircle,
  ClipboardCheck,
  ClipboardList,
  Container as ContainerIcon,
  FileCheck2,
  FileText,
  History,
  Inbox,
  LayoutDashboard,
  ListChecks,
  MapPin,
  MessageSquare,
  Package,
  PackageOpen,
  Send,
  Settings,
  ShoppingCart,
  Truck,
  Undo2,
  Wrench,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /**
   * When set, the module is not built yet. It stays visible so the shape of the
   * product is legible, but it leads to an honest "à venir" page instead of a
   * screen full of invented data.
   */
  comingSoon?: string;
}

/** Desktop sidebar, in the order of the Frontend Spec §3. */
export const NAV_ITEMS: NavItem[] = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/inventory", label: "Inventaire", icon: Boxes },
  { to: "/products", label: "Produits", icon: Package },
  { to: "/locations", label: "Emplacements", icon: MapPin },
  { to: "/containers", label: "Contenants", icon: ContainerIcon },
  { to: "/assets", label: "Outils / Assets", icon: Wrench },
  { to: "/history", label: "Historique", icon: History },
  { to: "/loans", label: "Prêts / Retours", icon: ClipboardList },
  { to: "/projects", label: "Projets / Chantiers", icon: ClipboardList },
  { to: "/lists", label: "Listes", icon: ListChecks },
  { to: "/estimates", label: "Estimations", icon: Calculator },
  { to: "/rfqs", label: "Demandes de prix", icon: FileText },
  { to: "/quotes", label: "Soumissions", icon: FileCheck2 },
  { to: "/messages/outgoing", label: "Messages sortants", icon: Send },
  { to: "/messages/incoming", label: "Messages reçus", icon: Inbox },
  { to: "/purchase-plans", label: "Plans d'achat", icon: ClipboardCheck },
  { to: "/commandes", label: "Commandes", icon: Truck },
  { to: "/retours-fournisseur", label: "Retours fournisseur", icon: Undo2 },
  { to: "/surplus", label: "Surplus de projet", icon: PackageOpen },
  { to: "/purchasing", label: "Achats / Réception", icon: ShoppingCart },
  { to: "/suppliers", label: "Fournisseurs", icon: Building2 },
  { to: "/policies", label: "Seuils / Réappro", icon: GaugeCircle },
  { to: "/assistant", label: "Conversation", icon: MessageSquare },
  { to: "/alerts", label: "Alertes", icon: Bell, comingSoon: "PHASE 11" },
  { to: "/settings", label: "Paramètres", icon: Settings, comingSoon: "à venir" },
];
